import React, { useState } from 'react';
import { Modal, Button, Form, Select, InputNumber, Input, Descriptions } from 'antd';
import { updateFgReview } from '../util/APIUtils';
import CurrencyInputNumber from '../common/CurrencyInputNumber';
import { currencyFormatter, currencyParser } from '../util/Helpers';

const { Option } = Select;

function FgReviewModal(props) {
    const [form] = Form.useForm();
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [comment, setComment] = useState(props.comment)
    const [approvalStatus, setApprovalStatus] = useState(props.approvalStatus)
    const [approvedAmount, setApprovedAmount] = useState(props.approvedAmount)


    const showModal = () => {
        setVisible(true);
    };

    const handleOk = () => {
        form
            .validateFields()
            .then((values) => {
                console.log(values)

                form.setFieldsValue({
                    approvedAmount: values.approvedAmount,
                    comment: values.comment,
                });
                let workFlowResponse = {
                    itemId: props.projectDetailId,
                    comment: values.comment,
                    fgStatus: values.approvalStatus,
                    approvedAmount: approvedAmount

                }
                console.log(workFlowResponse)
                let promise;
                setLoading(true)
                promise = updateFgReview(workFlowResponse);
                if (!promise) {
                    return;
                }

                promise.then(response => {
                    setLoading(false)
                    setVisible(false);
                    props.refetch()

                }).catch(error => {
                    setLoading(false)
                });
            })
            .catch((info) => {
                console.error('Validate Failed:', info);
            });
    };

    const handleCancel = () => {
        setVisible(false);
    };

    // form.resetFields()

    const getStatusValue = (val) => {
        let st = null;
        switch (val) {
            case "abgelehnt":
                st = 0;
                break;
            case "ok":
                st = 1;
                break;

            case "zurückgestellt":
                st = -1;
                break;
            default:
                break;
        }

        return st
    }

    let initVals = {
        comment: comment,
        approvalStatus: getStatusValue(approvalStatus),
        approvedAmount: approvedAmount
    }

    const updateAmount = (val) => {
        if (val != 1) {
            form.setFieldValue({
                approvedAmount: 0
            })
        }
    }

    return (
        <>
            <Button size='small' style={{ float: 'right' }} type="primary" onClick={showModal}>
                Evaluieren
            </Button>
            <Modal
                forceRender
                title={"FG-Evaluation - " + props.projectNumber}
                visible={visible}
                onOk={handleOk}
                onCancel={handleCancel}
                confirmLoading={loading}
            >
                <Form form={form} initialValues={initVals}
                    onValuesChange={(changedValues, allValues) => {

                        if (changedValues.hasOwnProperty('approvalStatus') && changedValues.approvalStatus != '1') {
                            form.setFieldsValue({ approvedAmount: 0 });
                        }
                    }}>
                    <Descriptions size='small' bordered>
                        <Descriptions.Item span={3} label="Status" >
                            <Form.Item
                                name="approvalStatus"
                                rules={[{ required: true, message: 'Pflichtfeld' }]}
                            >
                                <Select onChange={setApprovalStatus}>
                                    <Option value={99}> </Option>
                                    <Option value={1}>ok</Option>
                                    <Option value={0}>abgelehnt</Option>
                                    <Option value={-1}>zurückgestellt</Option>
                                </Select>
                            </Form.Item>
                        </Descriptions.Item>
                        <Descriptions.Item label="Bemerkungen" span={3}  >
                            <Form.Item
                                name="comment"
                                rules={[{ required: true, message: 'Pflichtfeld' }]}
                            >
                                <Input.TextArea rows={4} onChange={setComment} />
                            </Form.Item>
                        </Descriptions.Item>
                        <Descriptions.Item label="Betrag" span={3} >
                            <Form.Item
                                name="approvedAmount"
                                validateTrigger={['onChange', 'onBlur']}
                                rules={[
                                    {
                                        required: true,
                                        message: 'Pflichtfeld',
                                    },
                                    ({ getFieldValue }) => ({
                                        validator(rule, value) {
                                            if (getFieldValue('approvalStatus') === 1 && (!value || value <= 0)) {
                                                return Promise.reject('Der genehmigte Betrag muss größer als Null sein, wenn der Genehmigungsstatus "ok" ist');
                                            }
                                            return Promise.resolve();
                                        },
                                    }),
                                ]}
                            >
                                <InputNumber
                                    formatter={currencyFormatter}
                                    parser={currencyParser}
                                    onChange={setApprovedAmount}
                                />

                            </Form.Item>






                        </Descriptions.Item>
                    </Descriptions>
                </Form>
            </Modal>
        </>
    );

}

export default FgReviewModal;
